<template>
  <div class="message-list">
    <van-nav-bar title="通知" left-text="返回" left-arrow @click-left="$router.go('-1')" />

    <div class="message-item van-hairline--top-bottom">
      <div class="message-item-user">
        <!-- <img
          class="message-item-user__img"
          src="https://user-gold-cdn.xitu.io/2020/1/9/16f896e086199562?imageView2/1/w/180/h/180/q/85/format/webp/interlace/1"
        /> -->
        <ul class="message-item-user__right" style="width: 100%;flex-wrap:wrap">
          <li v-if="index == 0" style="width: 100%;text-align:center">
            {{ item.title }}
          </li>
          <li v-if="index == 1" style="width: 100%;text-align:center">
            {{ item.opt_user_name }}
          </li>
          <li v-if="index == 2" style="width: 100%;text-align:center">
            官方小甜甜
          </li>
          <li style="width: 100%;text-align:center" class="message-item-user__right__date">
            {{ item.create_ad }}
          </li>
        </ul>
      </div>
      <p v-if="index == 0 || index == 1" class="message-item-content">
        {{ item.content }}
      </p>
      <p v-if="index == 2" class="message-item-content">
        {{ item.msg }}
      </p>
    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant'

export default {
  components: {
    'van-nav-bar': NavBar
  },
  data() {
    return {
      item: null,
      index: localStorage.getItem('messageItemIndex')
    }
  },
  created() {
    this.getData()
    if (this.index == 0) {
      this.$http.json_post(this.$api.message.editSchoolNotice, {
        id: this.item.id
      })
    } else if (this.index == 1) {
      this.$http.json_post(this.$api.message.editWork, {
        id: this.item.id
      })
    } else {
      this.$http.json_post(this.$api.message.editCard, {
        id: this.item.id,
        state: 1
      })
    }
  },
  methods: {
    getData() {
      this.item = JSON.parse(localStorage.getItem('messageItem'))
      console.log(JSON.parse(localStorage.getItem('messageItem')))
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin-top: $space;
  padding: 16px;
  background: $background-color;
  &:last-of-type {
    margin-bottom: $space;
  }
  .message-item-user {
    display: flex;
    align-items: center;
    .message-item-user__img {
      width: 30px;
      border-radius: 50%;
    }
    .message-item-user__right {
      display: flex;
      justify-content: center;
      // padding-left: 10px;
      .message-item-user__right__date {
        padding-top: 5px;
        color: $text-secondary-color;
        font-size: 12px;
      }
    }
  }
  .message-item-content {
    padding-top: 10px;
    line-height: 20px;
  }
}
</style>
